window.addEventListener('load', () => {
  setTimeout(() => {
    const sliderEl = document.querySelector('.js-media-mobile-list');
    if (!sliderEl) return;

    const hasHiddenSlides = [...sliderEl.querySelectorAll('.swiper-slide')]
      .some(s => s.style.display === 'none');

    const key = 'imgix_reload_' + window.location.pathname;
    if (hasHiddenSlides && !sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, '1');
      window.location.reload();
    }
  }, 800);
});

function fixDesktopGrid() {
  if (window.innerWidth < 990) return;
  document.querySelectorAll(
    '.product__media-list:not(.js-media-mobile-list) .product__media-item .product__media'
  ).forEach(el => {
    el.style.setProperty('padding-top', '133.33%', 'important');
  });
}